import React from 'react';
import ReactDOM from 'react-dom';
import { ThemeProvider } from 'styled-components'
import { BrowserRouter } from 'react-router-dom'

import { UserContextProvider } from './hooks/UserContext';
import { WishListContextProvider } from './hooks/WishListContext'
import { SearchContextProvider } from './hooks/SearchContext';
import { FilterContextProvider } from './hooks/FilterContext';

import MainTheme from './styles/Theme/MainTheme';

import App from './App';

import reportWebVitals from './reportWebVitals';

ReactDOM.render(
  <React.StrictMode>
    <BrowserRouter>
      <ThemeProvider theme={MainTheme}>
        <UserContextProvider>
          <FilterContextProvider>
          <WishListContextProvider>
            <SearchContextProvider>
              <App />
            </SearchContextProvider>
          </WishListContextProvider>
          </FilterContextProvider>
        </UserContextProvider>
      </ThemeProvider>
    </BrowserRouter>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
